var radius$1={xs:{value:"4px"},sm:{value:"8px"},md:{value:"16px"},rounded:{value:"100px"}};var tokens = {radius:radius$1};

var radius = {
    xs: tokens.radius.xs.value,
    sm: tokens.radius.sm.value,
    md: tokens.radius.md.value,
    rounded: tokens.radius.rounded.value,
};

export { radius as r };
//# sourceMappingURL=radius-2ce46c77.js.map
